const mapStateToProps = state => 
    ({
        menu: state.security.menu,
        tabModuloMenu: state.fallecidos.tabModuloMenu,
        arrayMenu: state.fallecidos.arrayMenu,
        firstRender: state.fallecidos.firstRender,
    });
export default mapStateToProps;
